"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = require("owa-bundling");
var createLazyPlugin_1 = require("owa-editor-lazy-plugin/lib/utils/createLazyPlugin");
owa_bundling_1.preloadScriptChunk('Editor');
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return System.import(/* webpackChunkName: "Editor" */ './lazyIndex');
});
// Delay loaded plugin
exports.LazyRibbonPluginClass = createLazyPlugin_1.default(lazyModule, function (m) { return m.RibbonPlugin; }, function () { return false; });
// Delay loaded components
exports.Ribbon = owa_bundling_1.createLazyComponent(lazyModule, function (m) { return m.Ribbon; });
// Delay loaded actions
exports.lazyUpdateRibbonWidth = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.updateRibbonWidth; });
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-editor-ribbonplugin/lib/index.js
// module id = 2216
// module chunks = 2 3 108